module.exports = __webpack_public_path__ + "static/media/Art2.aeee4483.pdf";